// extracted by mini-css-extract-plugin
module.exports = {"dark":"Policy_dark__AdnTd","legal":"Policy_legal__1MqhU","title":"Policy_title__1sPCW","subtitle":"Policy_subtitle__DpnGy","paragraph":"Policy_paragraph__3AQ8E"};